export const frequencyOptions = [
    {
        value: 'Daily',
        label: 'Daily',
    },
    {
        value: 'Weekly',
        label: 'Weekly',
    },
    {
        value: 'Monthly',
        label: 'Monthly',
    }
];
export const moduleOptions = [
    {
        value: 'Circular 09 Compliance',
        label: 'Circular 09 Compliance',
    },
    {
        value: 'CIS BenchMark',
        label: 'CIS BenchMark',
    },
    {
        value: 'Cloud Cost Insights',
        label: 'Cloud Cost Insights',
    },
    {
        value: 'LDAP Private',
        label: 'LDAP Private',
    },
    {
        value: 'Security Hub Findings',
        label: 'Security Hub Findings',
    },
    {
        value: 'TRMG Compliance',
        label: 'TRMG Compliance',
    },
    {
        value: 'Vulnerability Management',
        label: 'Vulnerability Management',
    },
    
];

const VMToolOptions = [
    {
        value: 'Tenable Nessus',
        label: 'Tenable Nessus',
    },
    {
        value: 'Trend Micro',
        label: 'Trend Micro',
    },
    {
        value: 'Symantec',
        label: 'Symantec',
    }
];
const AWSToolOption = [{
    value : 'AWS',
    label: 'AWS',
}];
const CISToolOption = [{
    value : 'Tenable Nessus',
    label: 'Tenable Nessus',
}];
const LDAPToolOption = [{
    value : 'Apache Directory',
    label: 'Apache Directory',
}];
export const ToolOptions = [
    {
        module: 'Circular 09 Compliance',
        option: AWSToolOption,
    },
    {
        module: 'CIS BenchMark',
        option: CISToolOption,
    },
    {
        module: 'Cloud Cost Insights',
        option: AWSToolOption,
    },
    {
        module: 'LDAP Private',
        option: LDAPToolOption,
    },
    {
        module: 'Security Hub Findings',
        option: AWSToolOption,
    },
    {
        module: 'TRMG Compliance',
        option: AWSToolOption,
    },
    {
        module: 'Vulnerability Management',
        option: VMToolOptions,
    },
];

export const formatDays = (inputDays) => {
    const dayArray = inputDays.split(',');
    const correctOrder = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
    const sortedDays = dayArray.sort((a, b) => correctOrder.indexOf(a) - correctOrder.indexOf(b));
    const formattedDays = sortedDays.map((day) => day.charAt(0).toUpperCase() + day.slice(1).toLowerCase());
    return formattedDays.join(', ');
};
export const sortStringNumber =(inputString) =>{
    const inputArray = inputString.split(',').map(Number);
    const sortedArray = [...inputArray].sort((a, b) => a - b);
    return sortedArray.join(', ');
}
export const dayOption = [
    { "label": "Sunday", "value": "Sunday" },
    { "label": "Monday", "value": "Monday" },
    { "label": "Tuesday", "value": "Tuesday" },
    { "label": "Wednesday", "value": "Wednesday" },
    { "label": "Thursday", "value": "Thursday" },
    { "label": "Friday", "value": "Friday" },
    { "label": "Saturday", "value": "Saturday" }
]